export interface Geolocation {
  latitude: number;
  longitude: number;
}

export const NullIsland: Readonly<Geolocation> = {
  latitude: 0,
  longitude: 0,
};
